import { render, staticRenderFns } from "./indexRight02.vue?vue&type=template&id=23b1ed22&scoped=true&"
import script from "./indexRight02.vue?vue&type=script&lang=js&"
export * from "./indexRight02.vue?vue&type=script&lang=js&"
import style0 from "./indexRight02.vue?vue&type=style&index=0&id=23b1ed22&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b1ed22",
  null
  
)

export default component.exports